import SitekeyForm from '../screens/SitekeyForm'
import SitekeyFormEdit from '../screens/SitekeyFormEdit'
import SitekeysList from '../screens/SitekeysList'
import { ROLE, RouteWithAccessType } from './types'

const sitekeyPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/sitekeys',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['sitekey.list.view'],
    component: <SitekeysList />
  },
  {
    route: '/sitekeys/:id/edit',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['sitekey.edit'],
    component: <SitekeyFormEdit />
  },
  {
    route: '/sitekeys/create',
    exact: true,
    rolesListWithReadAccess: [ROLE.ADMIN],
    rolesListWithWriteAccess: [ROLE.ADMIN],
    requiredFeatures: ['sitekey.create'],
    component: <SitekeyForm />
  }
]

export default sitekeyPagesRoleManagement
